export default __webpack_public_path__ + "static/media/clean.df19b4b6.png";